import * as React from "react";

function Grupo7762(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={58.183} height={51.157} {...props}>
      <g data-name="Grupo 7762" fill="#bc0101" stroke="#bc0101">
        <path
          data-name="Caminho 8930"
          d="M23.578 9.281l-3.541 7.57h18.668l-5.291-7.57z"
        />
        <path
          data-name="Uni\xE3o 38"
          d="M19.454 50.757H.4v-1.17h3.513V26.75H.4v-1.172h57.382v1.172h-3.513v22.836h3.513v1.17zM39.9 49.585h13.2V38.641H39.9zm-20.446 0H38.73V26.75H19.454zm-14.369 0h13.2V38.642h-13.2zM39.9 37.472h13.2V26.75H39.9zm-34.816 0h13.2V26.75H5.085zM44.041 44.7v-1.168h4.931V44.7zm-34.821 0v-1.168h4.93V44.7zm34.821-11.533V32h4.931v1.17zm-34.821 0V32h4.93v1.17zm9.222-15.2l5.088-9.228V.4h11.126v8.339l5.088 9.227zM20.42 16.8h17.345l-4.041-7.324h-9.263zm4.28-8.5h8.783V1.572H24.7z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.8}
        />
      </g>
    </svg>
  );
}

const MemoGrupo7762 = React.memo(Grupo7762);
export default MemoGrupo7762;
